import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/space-travel-store/space-travel-store.ts
var r = e((e, t) => ({
	request: void 0,
	phase: "idle",
	requestSpaceTravel: (n, r, i, a) => {
		t().phase === "idle" && e({
			request: {
				targetSpaceId: n,
				reason: r,
				transitionType: i,
				thumbnailUrl: a
			},
			phase: "requested"
		});
	},
	setPhase: (t) => e({ phase: t }),
	setTravelThumbnail: (n) => {
		let r = t().request;
		r && !r.thumbnailUrl && e({ request: {
			...r,
			thumbnailUrl: n
		} });
	},
	resetTravel: () => e({
		request: void 0,
		phase: "idle"
	})
})), i = (e) => t(r, n(e));
//#endregion
export { r as spaceTravelStore, i as useSpaceTravelStore };
